import { memo, useCallback, useMemo } from "react";

import { cn } from "@/lib/chillnn/cn";
import type { PlainWidgetDecoration } from "@/lib/gql/__generated__/graphql";

import { WidgetDecoration } from "@/components/features/design/plain/ui/components/main/widget-decoration";

type Props = {
	title: string;
	thumbnail: string;
	primaryColor: string;
	target: PlainWidgetDecoration;
	current: PlainWidgetDecoration;

	onClickCard: (value: PlainWidgetDecoration) => void;
};

export const PlainWidgetDecorationCard = memo(
	({ title, thumbnail, primaryColor, target, current, onClickCard }: Props) => {
		const handleClickCard = useCallback(() => {
			onClickCard(target);
		}, [onClickCard, target]);

		const active = useMemo(() => current === target, [current, target]);

		return (
			<div
				className={cn(
					"box-border w-full min-w-72 max-w-xs cursor-pointer rounded-lg border-[3px] border-zinc-400 p-2 px-4 hover:opacity-60 ",
					active && "border-brand",
				)}
				onClick={handleClickCard}
			>
				<div className="max-h-48 min-h-48">
					<WidgetDecoration
						thumbnail={thumbnail}
						primaryColor={primaryColor}
						plainWidgetDecoration={target}
					/>
				</div>
				<div className="mt-4">
					<p className="text-center">{title}</p>
				</div>
			</div>
		);
	},
);
